module.exports = __webpack_public_path__ + "static/media/mouseteeth.3a121671.wav";